import {
  INVITATION_CHANNEL,
  INVITATION_EXPIRY_DAYS_IN_MS,
  INVITATION_STATUS,
} from '../invitation/invitation.interface';
import type { Invitation } from '../invitation/invitation.interface';
import { baseDocumentFactory } from './base-document.factory';
import { ObjectFactory } from './object.factory';

export class InvitationFactory extends ObjectFactory<Invitation> {
  protected getDefaults(): Invitation {
    return {
      ...baseDocumentFactory.build(),
      activationLink: 'http://localhost:3100/frontoffice/activate?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9',
      channel: INVITATION_CHANNEL.EMAIL,
      email: 'test@example.com',
      expiresAt: new Date(Date.now() + INVITATION_EXPIRY_DAYS_IN_MS),
      lastSentAt: null,
      status: INVITATION_STATUS.CREATED,
      tokenNonce: 1,
      userId: 'aabbccddeeff001122334455',
    };
  }
}

export const invitationFactory = new InvitationFactory();
